import React from 'react';
import { Button as AntdButton } from 'antd';

// Wrap the AntD Button to provide default props and styling
export const Button = (props) => {
    return <AntdButton shape="round" {...props} />;
};
